var _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_5433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_5433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.81 6.77L14.76 7.82C13.9381 7.28673 12.9797 7.00201 12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7.00201 12.9797 7.28674 13.9381 7.82 14.76L6.29 16.29C3.7 14.75 2 12.62 2 12C2 11 6.48 6 12 6C13.3075 6.01106 14.6008 6.27244 15.81 6.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 13 17.52 18 12 18C10.6925 17.9889 9.39919 17.7275 8.19 17.23L9.24 16.18C10.0619 16.7132 11.0203 16.998 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5978 17 13.326 17 12C16.998 11.0202 16.7133 10.0619 16.18 9.23996L17.71 7.70996C20.3 9.24996 22 11.38 22 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 9.29L9.29 13.29C9.10139 12.886 9.00246 12.4459 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.4459 9.00246 12.886 9.10139 13.29 9.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 12.7956 14.684 13.5587 14.1213 14.1213C13.5587 14.6839 12.7957 15 12 15C11.5541 14.9975 11.1141 14.8986 10.71 14.71L14.71 10.71C14.8986 11.114 14.9976 11.5541 15 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.5L5.5 18.5",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_5433)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#008E96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_5433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/Invisible.f54f5ff1e0a17e84b440b5c6ec82ff99.svg";
export { ForwardRef as ReactComponent };